import React from "react";
import { Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { HomePage } from "./pages/HomePage";
import { ServicesPage } from "./pages/ServicesPage";
import { PuppyPage } from "./pages/PuppyPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { GalleryPage } from "./pages/GalleryPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ForbiddenPage } from "./pages/ForbiddenPage";

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-[#FEFAF3] text-black antialiased">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ydelser-priser" element={<ServicesPage />} />
          <Route path="/ydelser" element={<ServicesPage />} />
          <Route path="/hvalpepakke" element={<PuppyPage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/om-hundens-pels-og-pleje" element={<AboutPage />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
